import { httpRequest } from "../../http";

export class CommandUnlinkBrandFont {
    async run(organizationId: string, brandId: string, fontId: number) {
        const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/organizations/${organizationId}/brands/${brandId}/fonts/${fontId}`;
        const response = await httpRequest<any>(url, { method: "DELETE" });
        return response;
    }
}
